/**
 * Attributes Object
 */
const memeSettings = {
	memeTextPosition: {
		type: 'string',
		default: 'bottom',
	},
	memeTextSize: {
		type: 'string',
		default: 'large',
	},
};

export default memeSettings;
